import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { languageLocaleChanged, LanguageLocaleChangedActionType, selectedLanguageUpdated } from '@/store/actions/language/languageLocaleChanged';

import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* changeSelectedLanguageSaga({ payload }: LanguageLocaleChangedActionType) {
  const timestamp = moment();
  const token = yield getAuthenticationToken();
  if (!token) return;
  const { languageEnum } = payload;
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.updatePlaceUserSelectedLanguage, token, { selectedLanguage: languageEnum });
  if (!response.error) {
    const responseAction = selectedLanguageUpdated({ timestamp });
    yield put(responseAction);
  }
}

export default function* watchChangeSelectedLanguageSaga() {
  yield takeEvery(languageLocaleChanged, changeSelectedLanguageSaga);
}
